// @flow
// Komponenty pouzite primarne v eshopu (odkomentujte v pripade eshopu, ale pozor obsahuje i univerzalne pouzitelne komponenty, pokud potrebujete, nebojte se pouzit - tj. presunout sem)
import configureEshopComponents from './configureEshopComponents';

export default (props) => {
  switch ( props.decorator || props.is ) {
    case 'GreedyMenu':
      // COMMON: Komponenta, ktera zajistuje, ze se vertikalni menu zobrazi vzdy pouze v jednom radku (odeberte, pokud na hlavni navigaci nepouzivate)
      return import('./components/GreedyMenu');
    // case 'Webslider':
    // COMMON: Komponenta webslideru (odeberte, pokud tuto promitacku nepouzivate)
    // return import ('fg-frontend/src/components/Webslider');
    case 'Tooltip':
      // COMMON: Napovedne popupy (odeberte, pokud v projektu nepouzivate, na eshopu napriklad na napovedy k parametrum a jako obecna knihovna pro zobrazovani napovednych textu)
      return import('./components/Tooltip');
    case 'GtmHandler':
      // COMMON: Komponenta, ktera upoznuje posilat do GTM Datalayeru zaznamu na zaklade zapisu v data atributech (odeberte, pokud GTM nepouzivate, jinak vyuzito primarne v eshopu)
      return import('./components/GtmHandler');
    case 'TriggerInViewport':
      // COMMON: Komponenta, ktera vystreli specialni udalost v okamziku, kdy se objevi ve viewportu (pomocna komponenta pro GtmHandler, odeberte, pokud nepouzivate GTMHandler]
      return import('./components/TriggerInViewport');
    // case 'LazyImage':
      // COMMON: Komponenta, ktera nastavi obrazek do rezimu lazy (odeberte, pokud nepouzivate lazy obrazky)
      // return import('./components/LazyImage');
    case 'Toggler':
      // COMMON: Komponenta pro prepinani HTML tridy na danem elementu
      return import('./components/Toggler');
    case 'SelectDesign':
      // COMMON: Ostylovani select inputu pomoci knihovny Select2 (odeberte, pokud ostylovani nepouzivate)
      return import('./components/SelectDesign');
    // case 'Countdown':
    // COMMON: Komponenta pro odpocet
    // return import('./components/Countdown');
    case 'ShowMorePhotos':
      // COMMON: Komponenta pro rozbaleni dalsich fotografii (TODO PDU: nahradit obecnejsi komponentou ListToggle)
      return import('./components/ShowMorePhotos');
    case 'AlertBox':
      // COMMON: Komponenta pro osetreni informacnich boxu (odeberte, pokud nepouzivate funkcionalitu/extenzi AlertBox)
      return import('fg-frontend/src/components/AlertBox');
    case 'InstagramFeed':
      // COMMON: Komponenta pro nacteni zakladniho instagram feedu
      return import('./components/InstagramFeed');
    // case 'AddSvgIconSprite':
    // COMMON: Komponenta pro AJAX nacteni SVG spritu
    // return import('./components/AddSvgIconSprite');
    case 'Typeahead':
      // COMMON: Komponenta obecneho naseptavace (odeberte, pokud nepouzivate RJ komponentu typeahead nebo v eshopu vychozi naseptavace pobocek dopravnich spolecnosti)
      return import('fg-frontend/components/Typeahead');
    case 'PasswordToggle':
      // COMMON: Komponenta pro zapnuti/vypnuti viditelnosti vkladaneho hesla (odeberte, pokud nepouzivate registration modul)
      return import('fg-frontend/components/PasswordToggle');
    case 'SocialShare':
      // COMMON: Komponenta pro sdileni linku na socialni site (odeberte, pokud nepouzivate sdileni linku na socialni site, napr. v eshopu v detailu produktu)
      return import('fg-frontend/src/components/SocialShare');
    case 'FGUpload':
      // COMMON: Komponenta pro multi upload souboru (odeberte, pokud nepouzivate RJ fileUpload komponentu)
      return import('./components/FGUpload');
    // case 'CloseableAlert':
    // COMMON: Zaviratelny alert (odeberte pokud na komponente messages nepouzivate moznost zavreni)
    // return import('fg-frontend/src/components/CloseableAlert');
    case 'GoogleRecaptcha':
      // COMMON: Google Recaptcha (odeberte pokud neupouzivate komponentu Google Recaptcha)
      return import('fg-frontend/src/components/GoogleRecaptcha');
    case 'PreventDoubleClickHandler':
      // COMMON: Komponenta zajistuje deaktivaci odkazu po prvnim kliknuti
      return import('fg-frontend/src/components/PreventDoubleClickHandler');

    case 'DatepickerSelectTab':
      return import('./components/DatepickerSelectTab');
    case 'BoxLink':
      return import('./components/BoxLink');
    case 'PresentScroll':
      return import('./components/PresentScroll');
    case 'PhotoSwipe':
      return import('./components/PhotoSwipe');
    case 'Shorter':
      return import('./components/Shorter');
    case 'AdvancedCarousel':
      return import('./components/AdvancedCarousel');
    case 'CarouselGallery':
      return import('./components/CarouselGallery');
    case 'RangeDatepicker':
      return import('./components/RangeDatepicker');
    case 'AgeHandler':
      // PROJECT: Komponenta modálního okna s potvrzením, že návštěvníkovi je více jak 18 let a může nakupovat alkohol/tabák
      return import('./components/AgeHandler');
    case 'Header':
      return import('./components/Header');

    default:
      const eshopComponent = configureEshopComponents(props);
      if ( eshopComponent ) {
        return eshopComponent;
      } else {
        console.log(`Unknown component ${ props.decorator || props.is }`);
        return null;
      }
  }
};



// WEBPACK FOOTER //
// ./fe/web-cigarhouse/src/js/configureWebComponents.js